export default "__VITE_ASSET__BC0mMmE2__"